<template>
    <div class="animated fadeIn">
        <item-availability/>
    </div>
</template>

<script>

    import itemAvailability from './itemAvailability'
    import config from 'SrcConfig'
    export default {
        name: "index",
        components: {itemAvailability},
        data () {
            return {
                modeType: 'Food',
                fields: [
                    { key: 'ModifierCategory', label: 'Modifier Group Name', sortable: false, class: '' },
                    { key: 'EditModifierBtn', label: '', sortable: false, class: '' },
                    { key: 'AppliesTo', label: 'Applies to', sortable: false, class: '' },
                    { key: 'IsOptional', label: 'Type', sortable: false, class: '' },
                    { key: 'Rule', label: 'Rule', sortable: false, class: '' },
                    { key: 'Modifiers', label: 'Modifier Options', sortable: false, class: '' },
                    { key: 'action', label: '', sortable: false, class: '' },
                ],
                items: [

                ],
                addModifierModal: false,
                editModifierModal: false,
                RestaurantMidifierCategoriesAll: [],
                addModifierOptionModal: false,
                newAddedCategory: null,
                editModalModifierGroup: false,
                selectedModifierGroup: null,
                editModifierOptionModal: false,
                selectedCategoryID: null,
                SelectedModifierCategoryName: null,
                selectedModifierName: null,
                selectedModifierOptional: null,
                selectedModifierChoiceOption: null,
                selectedModifierChoiceNumber: null,
                AllowSecondLang: false
            }
        },
        metaInfo () {
            return {
                title: 'Item availability'
            }
        },
        methods: {
            goMenuEditorPage () {
                //go menu editor
                window.open(`${config.websiteUrl}/${this.$store.state.menuEditorLink}`, '_blank')
            }
        }
    }
</script>

<style scoped>
    .goMenuHeaderBtn{
        background: #6f7882 !important;
        color: #fff !important;
    }
    .activeBtn {
        background: #f5c31d !important;
        border-color: #c8ced3 !important;
        font-weight: bold;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #c8ced3 !important;
        color: #c8ced3 !important;
        font-weight: bold;
    }
</style>
